// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3CURl","info":"PatientInfo_info__1a3e8"};